<template>
  <nav class="mobile-bottom-nav d-md-none">
    <div class="nav-items-wrapper">
      <!-- Kios -->
      <router-link to="/people/kios-list" class="nav-item-link" active-class="active">
        <div class="nav-icon-box">
          <vue-feather type="home" size="22"></vue-feather>
        </div>
        <span class="nav-label">Kios</span>
      </router-link>

      <!-- Order -->
      <router-link to="/purchases/purchase-list" class="nav-item-link" active-class="active">
        <div class="nav-icon-box">
          <vue-feather type="clipboard" size="22"></vue-feather>
        </div>
        <span class="nav-label">Order</span>
      </router-link>

      <!-- Produk -->
      <router-link to="/inventory/product-list" class="nav-item-link" active-class="active">
        <div class="nav-icon-box">
          <vue-feather type="package" size="22"></vue-feather>
        </div>
        <span class="nav-label">Produk</span>
      </router-link>

      <!-- Profile -->
      <router-link to="/pages/profile" class="nav-item-link" active-class="active">
        <div class="nav-icon-box">
          <vue-feather type="user" size="22"></vue-feather>
        </div>
        <span class="nav-label">Profile</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MobileBottomNav'
}
</script>

<style scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(15px);
  height: 70px;
  z-index: 1050;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding: 10px 10px 15px 10px;
  display: flex;
  box-shadow: 0 -5px 25px rgba(0,0,0,0.03);
}

.nav-items-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  position: relative;
}

.nav-item-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #64748b; /* Cool Slate 500 */
  flex: 1;
  transition: all 0.2s ease;
  gap: 4px;
}

.nav-item-link.active {
  color: #029147;
}

.nav-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  transition: transform 0.2s ease;
}

.nav-item-link.active .nav-icon-box {
  transform: translateY(-2px);
}

.nav-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.nav-item-link.active .nav-label {
  font-weight: 800;
}
</style>
